export const ENTITY = 'ttd-health-audiences'

export const INITIAL_STATE = {
  name: '',
  condition: '',
  id: '',
}

export const TABLE_COLUMNS_SINGULAR = [
  {
    name: 'Batch Id',
    key: 'batchId',
  },
  {
    name: 'Processing Status',
    key: 'processingStatus',
    styles: { textAlign: 'left' },
  },
  {
    name: 'Estimated Process At Utc',
    key: 'estimatedProcessAtUtc',
    styles: { textAlign: 'left' },
  },
  {
    name: 'Processed At Utc',
    key: 'processedAtUtc',
    styles: { textAlign: 'left' },
  },
]
